import { KeyValue } from '@angular/common';
import { createAction, props } from '@ngrx/store';
import {
    CandidateDocumentDetail,
    CandidateDocumentHistory
} from 'src/app/compliance/models/candidate-document-detail.model';
import { Contract } from 'src/app/compliance/models/contract';
import { DocumentType } from 'src/app/compliance/models/document-type';
import { DocumentUploadToolDetailDto } from '../../api/models/document-upload-tool-detail-dto.model';
import { RejectDocumentArgs } from '../../models/posted-documents-models';
import { DocumentTypeRequirementTextDto } from '../../api/models/document-type-requirement-text-dto.model';
import { DocumentTypeConfigurationRequirementDto } from '../../api/models/document-type-configuration-requirement-dto.model';

export const loadDocumentDetails = createAction('[DOCUMENT REVIEWER API] Load Document Details');
export const loadDocumentDetailsSuccess = createAction(
    '[DOCUMENT REVIEWER] Load Document Details Success',
    props<{ details: CandidateDocumentDetail }>()
);
export const loadDocumentDetailsFailure = createAction(
    '[DOCUMENT REVIEWER] Load Document Details Failed',
    props<{ error: unknown }>()
);

export const loadDocumentIds = createAction('[DOCUMENT PREVIEWER API] Load Document Ids');
export const loadDocumentIdsSuccess = createAction(
    '[DOCUMENT REVIEWER] Load Document Ids Success',
    props<{ documentIds: number[] }>()
);
export const loadDocumentIdsFailure = createAction(
    '[DOCUMENT REVIEWER] Load Document Ids Failed',
    props<{ error: unknown }>()
);

export const selectedDocumentId = createAction(
    '[DOCUMENT REVIEWER API] Selected Document Id',
    props<{ documentId: number }>()
);
export const selectedDocumentType = createAction(
    '[DOCUMENT REVIEWER] Selected Document Type',
    props<{ documentType: DocumentType }>()
);

export const loadCandidateLiaisonNameByContractIdSuccess = createAction(
    '[DOCUMENT REVIEWER] Load Candidate Liaison Name by ContarctId Success',
    props<{ candidateLiaison: any }>()
);
export const loadCandidateLiaisonNameByContractId = createAction(
    '[DOCUMENT REVIEWER] Load Candidate Liaison Name by ContarctId',
    props<{ contractId: number }>()
);
export const resetCandidateLiaisonName = createAction('[DOCUMENT REVIEWER] Reset Candidate Liaison Name');

export const loadCandidateDocumentByDocumentId = createAction(
    '[DOCUMENT REVIEWER API] Load Candidate Document By Document Id'
);
export const loadCandidateDocumentByDocumentIdSuccess = createAction(
    '[DOCUMENT REVIEWER] Load Candidate Document By Document Id Success',
    props<{ candidateDocument: DocumentUploadToolDetailDto }>()
);
export const loadCandidateDocumentByDocumentIdFailure = createAction(
    '[DOCUMENT REVIEWER] Load Candidate Document By Document Id Failure',
    props<{ error: unknown }>()
);

export const loadDocumentAsPdf = createAction(
    '[DOCUMENT REVIEWER API] Load Document As Pdf',
    props<{ documentId?: number }>()
);
export const loadDocumentAsPdfSuccess = createAction(
    '[DOCUMENT REVIEWER] Load Document As Pdf Success',
    props<{ document: any }>()
);
export const loadDocumentAsPdfFailure = createAction(
    '[DOCUMENT REVIEWER] Load Document As Pdf Failure',
    props<{ error: unknown }>()
);

export const loadDocumentTypes = createAction('[DOCUMENT PREVIEWER API] Load Document Types');
export const loadDocumentTypesSuccess = createAction(
    '[DOCUMENT REVIEWER] Load Document Types Success',
    props<{ types: DocumentType[] }>()
);
export const loadDocumentTypesFailure = createAction(
    '[DOCUMENT REVIEWER] Load Document Types Failure',
    props<{ error: unknown }>()
);

export const loadDocumentTypeById = createAction('[DOCUMENT REVIEWER API] Load Document Type Id');
export const loadDocumentTypeByIdSuccess = createAction(
    '[DOCUMENT REVIEWER] Load Document Type Id Success',
    props<{ documentType: DocumentType }>()
);
export const loadDocumentTypeByIdFailure = createAction(
    '[DOCUMENT REVIEWER] Load Document Type Id Failure',
    props<{ error: unknown }>()
);

export const loadDocumentTypeTextRequirements = createAction(
    '[DOCUMENT REVIEWER API] Load Document Type Text Requirements'
);
export const loadDocumentTypeTextRequirementsSuccess = createAction(
    '[DOCUMENT REVIEWER] Load Document Type Text Requirements Success',
    props<{ documentTextRequirements: DocumentTypeRequirementTextDto[] }>()
);

export const loadDocumentTypeRequirementDescriptionsSuccess = createAction(
    '[DOCUMENT REVIEWER] Load Document Type Requirement Descriptions Success',
    props<{ documentTypeRequirementDescriptions: DocumentTypeConfigurationRequirementDto[] }>()
);

export const loadDocumentTypeRequirementDescriptionsFailure = createAction(
    '[DOCUMENT REVIEWER] Load Document Type Requirement Descriptions Failure',
    props<{ error: unknown }>()
);

export const loadDocumentTypeTextRequirementsFailure = createAction(
    '[DOCUMENT REVIEWER] Load Document Type Text Requirements Failure',
    props<{ error: unknown }>()
);

export const loadCandidateInformation = createAction(
    '[DOCUMENT REVIEWER] Load Candidate Information by Id',
    props<{ candidateId: number }>()
);
export const loadCandidateInformationSuccess = createAction(
    '[DOCUMENT REVIEWER API] Loaded Candidate Information Success',
    props<{ candidateInfo: unknown }>()
);
export const loadCandidateInformationFailure = createAction(
    '[DOCUMENT REVIEWER API] Loaded Candidate Information Failure',
    props<{ error: unknown }>()
);

export const searchDocumentTypesByName = createAction(
    '[DOCUMENT REVIEWER API] Search Document Types By Name',
    props<{ searchText: string }>()
);
export const searchDocumentTypesByNameSuccess = createAction(
    '[DOCUMENT REVIEWER] Search Document Types By Name Success',
    props<{ types: DocumentType[] }>()
);
export const searchDocumentTypesByNameFailure = createAction(
    '[DOCUMENT REVIEWER] Search Document Types By Name Failure',
    props<{ error: unknown }>()
);
export const resetDocumentTypes = createAction('[DOCUMENT REVIEWER] Reset Document Types');

export const rejectedDocumentSuccess = createAction(
    '[DOCUMENT REVIEWER] Reject Candidate Document Successfully',
    props<{ success: boolean }>()
);
export const rejectedDocumentPages = createAction(
    '[DOCUMENT REVIEWER] Rejected Document Pages Successfully',
    props<{ pages: { pageNumber: number; rotation: number }[] }>()
);
export const rejectedDocumentArgs = createAction(
    '[DOCUMENT REVIEWER] Rejected Document Args',
    props<{ rejectedDocumentArgs: RejectDocumentArgs }>()
);

export const contractSelected = createAction(
    '[DOCUMENT REVIEWER] Document Reviewer Contract Selected',
    props<{ contract: Contract }>()
);
export const noteAdded = createAction('[DOCUMENT REVIEWER] Document Reviewer Note Added', props<{ note: string }>());
export const resetReviewer = createAction('[DOCUMENT REVIEWER] Reset Document Reviewer');
export const resetReviewerInfo = createAction('[DOCUMENT REVIEWER] Reset Document Reviewer Information');

export const setPagesRendered = createAction(
    '[DOCUMENT REVIEWER] Set Pages Rendered',
    props<{ pages: { pageNumber: number; rotation: number }[] }>()
);

export const setMergeOption = createAction(
    '[DOCUMENT REVIEWER] Set Merge Option Document Conflict',
    props<{ mergeOption: number }>()
);

export const setCurrentReviewerStep = createAction(
    '[DOCUMENT REVIEWER] Set Current Reviewer Step',
    props<{ step: number }>()
);
export const setPreviousReviewerStep = createAction(
    '[DOCUMENT REVIEWER] Set Previous Reviewer Step',
    props<{ step: number }>()
);

export const setCandidateId = createAction('[DOCUMENT REVIEWER] Set Candidate Id', props<{ candidateId: number }>());
export const setAssignedUploaderId = createAction(
    '[DOCUMENT REVIEWER] Set Assigned Uploader Id',
    props<{ assignedUploaderId: number }>()
);
export const setIsSignedContract = createAction(
    '[DOCUMENT REVIEWER] Set Is Signed Contract',
    props<{ isSignedContract: boolean }>()
);
export const setIsCandidateUpload = createAction(
    '[DOCUMENT REVIEWER] Set Is Candidate Upload',
    props<{ isCandidateUpload: boolean }>()
);

export const setReassignInLegacy = createAction(
    '[DOCUMENT REVIEWER] Reassign Pages with Legacy Document Previewer',
    props<{ reassign: boolean }>()
);

export const goToBatchDetails = createAction(
    '[DOCUMENT REVIEWER] Go To Document Batch Details',
    props<{ url: string; newTab?: boolean }>()
);
export const goToLegacyReassignPage = createAction(
    '[DOCUMENT REVIEWER ROUTER] Go To Legacy Reassign Pages Page',
    props<{ documentId: number }>()
);

export const setDocumentStatusMovedToWaste = createAction(
    '[DOCUMENT REVIEWER MERGE MODAL COMPONENT] Document Moved To Waste Status',
    props<{ status: boolean }>()
);
export const setAllPagesSelectedStatus = createAction(
    '[DOCUMENT REVIEWER] Set All Pages Selected Status',
    props<{ status: boolean }>()
);

export const loadVaccineManufacturers = createAction('[DOCUMENT REVIEWER] Load Vaccine Manufacturers');
export const loadVaccineManufacturersSuccess = createAction(
    '[DOCUMENT REVIEWER] Load Vaccine Manufacturers Success',
    props<{ manufacturers: KeyValue<number, string>[] }>()
);
export const loadVaccineManufacturersFailure = createAction(
    '[DOCUMENT REVIEWER] Load Vaccine Manufacturers Failure',
    props<{ error: unknown }>()
);

export const setVaccineDate = createAction('[DOCUMENT REVIEWER] Set Vaccine Date', props<{ date: string }>());
export const setVaccineManufacturer = createAction(
    '[DOCUMENT REVIEWER] Set Vaccine Manufacturer',
    props<{ manufacturer: number }>()
);
export const setVaccineExemption = createAction('[DOCUMENT REVIEWER] Set Vaccine Exemption', props<{ date: string }>());
export const setFormStatus = createAction('[DOCUMENT REVIEWER] Set Form Status', props<{ isValid: boolean }>());
export const setDoseLotNum = createAction('[DOCUMENT REVIEWER] Set Dose Lot Num', props<{ value: string }>());
export const setDoseEstablishment = createAction(
    '[DOCUMENT REVIEWER] Set Dose Establishment',
    props<{ value: string }>()
);
export const setDoseCity = createAction('[DOCUMENT REVIEWER] Set Dose City', props<{ value: string }>());
export const setDoseStateId = createAction('[DOCUMENT REVIEWER] Set Dose State ID', props<{ value: number }>());

export const setCandidateDocumentHistory = createAction(
    '[DOCUMENT REVIEWER] Set Document History',
    props<{ value: CandidateDocumentHistory }>()
);

export const confirmHasBeenClicked = createAction('[DOCUMENT REVIEWER] Document Reviewer Confirm');
